import React, { useState, useEffect, useRef } from "react";
import "./searchFields.css";
import NoLenderModal from "./components/noLenderModal";
import { InputNumber, Select, Checkbox, Tooltip, Modal, message, Button } from "antd";
import * as com from "../../../../Common.js";
import * as common from "./../common/common.js";
import LodestarTipsCard from "../../../../Management/estimatedclosingfee/components/LodestarTipsCard";
import ClosingCost from "../../../../Management/estimatedclosingfee/components/ClosingCost";
import Lenders from "../../../../Management/Lenders";
import { checkAccess } from "Auth";
import { UR_Owner } from "../../../../State.js";
import {
  parseSearchFieldsFromUrlQuery,
  matchCountyInLoanLimits,
} from "./queryParams";

/** 深链模式：仅预填 URL 中出现的字段，其余留空；普通进入：沿用表单原默认值 */
function pickInitial(deepLink, field, legacyDefault, emptyValue = null) {
  if (!deepLink?.fromDeepLink) return legacyDefault;
  return Object.prototype.hasOwnProperty.call(deepLink, field)
    ? deepLink[field]
    : emptyValue;
}

const SearchFields = ({ onCheckRates, historyParams , onBackToResult}) => {
  const [deepLinkInitial] = useState(() => parseSearchFieldsFromUrlQuery());
  const fromDeepLink = deepLinkInitial?.fromDeepLink === true;
  const queryCountySyncedRef = useRef(false);
  const [showEditCostDetails, setShowEditCostDetails] = useState(false);
  const [lodeStarConfig, setLodeStarConfig] = useState({
    suggestEnableCount: 1,
    isModified: false,
    enableOriginationCharges: false,
    enableCanNotShopServices: false,
    enableCanShopServices: false,
    enableTaxesAndOtherGovernmentFees: false,
    enablePrepaids: false,
    enableInitialEscrowPaymentsAtClosing: false,
    enableOther: false,
  });
  const [closingFeeConfig, setClosingFeeConfig] = useState({
    originationCharges: null,
    canNotShopServices: null,
    canShopServices: null,
    taxesAndOtherGovernmentFees: null,
    prepaids: null,
    initialEscrowPaymentsAtClosing: null,
    other: null,
  });
  const [totalClosingFee, setTotalClosingFee] = useState(0);
  const closingCostRef = useRef();

  const [isOpen_no_lender, setIsOpen_no_lender] = useState(false);
  const [isCalculatedAtResults, setIsCalculatedAtResults] = useState(false);
  const [hasLenders, setHasLenders] = useState(false);
  const [shouldCheckRatesAfterLenderUpdate, setShouldCheckRatesAfterLenderUpdate] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [connectedLendersMap, setConnectedLendersMap] = useState({});
  // const [resultlenderSet, setResultlenderSet] = useState(new Set());
  // const [lenderData, setLenderData] = useState([]);
  // const [selectedLenders, setSelectedLenders] = useState([]);
  // const [showConnectedLendersOnly, setShowConnectedLendersOnly] =
  //   useState(false);
  // const [showIneligible, setShowIneligible] = useState(false);
  // const [showAddLendersModal, setShowAddLendersModal] = useState(false);
  // const [ineligibleProducts, setIneligibleProducts] = useState({});
  // const [noProducts, setNoProducts] = useState(false);
  // const [productTypes, setProductTypes] = useState([]);
  // const [loans, setLoans] = useState([]);
  // const [indexFixed30, setIndexFixed30] = useState(0);
  // const [indexFixed25, setIndexFixed25] = useState(0);
  // const [indexFixed20, setIndexFixed20] = useState(0);
  // const [indexFixed15, setIndexFixed15] = useState(0);
  // const [indexFixed10, setIndexFixed10] = useState(0);
  // const [indexArm56, setIndexArm56] = useState(0);
  // const [indexArm76, setIndexArm76] = useState(0);
  // const [indexArm106, setIndexArm106] = useState(0);
  // const [selectedAUS, setSelectedAUS] = useState([]);
  // const [allRates, setAllRates] = useState({});
  const [searchBy, setSearchBy] = useState("price");
  const [targetRate, setTargetRate] = useState(null);
  const [targetRateMessage, setTargetRateMessage] = useState('');
  const [from, setFrom] = useState("search");
  const [isLoading, setIsLoading] = useState(false);

  // 产品类型映射
  const productTypesMap = {
    Conventional: ["CONV", "CONV_HIGH_BALANCE"],
    FHA: ["FHA"],
    VA: ["VA"],
    USDA: ["USDA"],
    Jumbo: ["JUMBO"],
  };

  // product
  const [targetPrice, setTargetPrice] = useState(100);
  const [targetPriceType, setTargetPriceType] = useState([""]); // calcOptions default select all
  const [lockDay, setLockDay] = useState(30);
  const [compensationType, setCompensationType] = useState("lender_paid");
  const [compensationPercent, setCompensationPercent] = useState(0);
  const [estimatedClosingFee, setEstimatedClosingFee] = useState(0);
  const [ausType, setAusType] = useState();
  const [buydown, setBuydown] = useState();

  // product

  // product
  const svg_expand = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.80039 5.15746L7.9165 6.04134L11.7462 9.871L7.91804 13.6991L8.80192 14.583L12.63 10.7549L12.6305 10.7554L13.5144 9.8715L13.5139 9.871L13.516 9.86896L12.6321 8.98508L12.63 8.98712L8.80039 5.15746Z" fill="#325CEB"/>
  </svg>
  }
  const updateTargetPrice = (value) => {
    if(value === null){
      setTargetRateMessage('Please enter target price');
      // return;
    }else if(value < 80 || value > 120){
      setTargetRateMessage('Target price must be between 80 and 120');
      // return;
    }else{
      setTargetRateMessage('');
    }
    setTargetPrice(value);
  };

  const updateTargetPriceType = (value) => {
    if (value.length > 2) {
      setTargetPriceType([""]);
    } else if (value.length > 1 && value.includes("") && value.length < 3) {
      setTargetPriceType(value.filter((item) => item !== ""));
    } else {
      setTargetPriceType(value);
    }
  };

  const updateLockDay = (value) => {
    setLockDay(value);
  };

  const updateCompensationType = (value) => {
    setCompensationType(value);
  };

  const updateCompensationPercent = (value) => {
    setCompensationPercent(value);
  };

  const updateEstimatedClosingFee = (value) => {
    setEstimatedClosingFee(value);
  };

  const updateAusType = (value) => {
    setAusType(value);
  };


  const updateBuydown = (value) => {
    setBuydown(value);
  };

  // product

  // borrower
  const [fico, setFico] = useState(pickInitial(deepLinkInitial, "fico", 780, null));
  const [monthlyIncome, setMonthlyIncome] = useState(
    pickInitial(deepLinkInitial, "monthlyIncome", 10000, null),
  );
  const [monthlyDebt, setMonthlyDebt] = useState(
    pickInitial(deepLinkInitial, "monthlyDebt", 1000, null),
  );
  const [dti, setDti] = useState(() => {
    if (!deepLinkInitial?.fromDeepLink) return 10;
    const { monthlyIncome, monthlyDebt } = deepLinkInitial;
    if (monthlyIncome > 0 && monthlyDebt != null) {
      return Number(((monthlyDebt / monthlyIncome) * 100).toFixed(2));
    }
    return null;
  });
  const [citizenship, setCitizenship] = useState("US_CITIZENS");
  const [isFirstTimeHomeBuyer, setIsFirstTimeHomeBuyer] = useState(true); // "Yes"
  const [isSelfEmployed, setIsSelfEmployed] = useState(false);
  const [isImpound, setIsImpound] = useState(true); // "Yes"
  const [isInterestOnly, setIsInterestOnly] = useState(false);
  const [isWaiveLenderFee, setIsWaiveLenderFee] = useState(false);
  const [ficoError, setFicoError] = useState("");

  // property
  const [occupancy, setOccupancy] = useState(
    pickInitial(deepLinkInitial, "occupancy", "principal", undefined),
  );
  const [propertyType, setPropertyType] = useState("singlefamilydetached");
  const [state, setState] = useState(
    pickInitial(deepLinkInitial, "state", "CALIFORNIA", undefined),
  );
  const [county, setCounty] = useState(
    pickInitial(deepLinkInitial, "county", "ALAMEDA COUNTY", undefined),
  );
  const [isRural, setIsRural] = useState(false);
  const [isMixedUse, setIsMixedUse] = useState(false);

  // borrower

  const updateFico = (value) => {
    if (value < 300 || value > 1000) {
      setFicoError("Enter a FICO score between 300 and 1000.");
    } else {
      setFicoError("");
    }
    setFico(Number(value));
  };

  const updateMonthlyIncome = (value) => {
    setMonthlyIncome(value);
    setDti(Number((monthlyDebt / value * 100).toFixed(2)));
  };

  const updateMonthlyDebt = (value) => {
    setMonthlyDebt(value);
    setDti(Number((value / monthlyIncome * 100).toFixed(2)));
  };

  const updateDti = (value) => {
    setDti(value);
  };

  const updateCitizenship = (value) => {
    setCitizenship(value);
  };

  const updateFirstTimeHomeBuyer = (e) => {
    setIsFirstTimeHomeBuyer(e.target.checked);
  };

  const updateSelfEmployed = (e) => {
    setIsSelfEmployed(e.target.checked);
  };

  const updateImpound = (e) => {
    setIsImpound(e.target.checked);
  };

  const updateInterestOnly = (e) => {
    setIsInterestOnly(e.target.checked);
  };

  const updateWaiveLenderFee = (e) => {
    setIsWaiveLenderFee(e.target.checked);
  };

  const updateOccupancy = (value) => {
    setOccupancy(value);
  };

  const updatePropertyType = (value) => {
    setPropertyType(value);
    if(value === 'manufacturedhome'){
      setLoanTerm('fixed25');
    }
  };

  const updateState = (value) => {
    setState(value);
    // 当state变化时，自动选择第一个可用的county
    if (value && value in loanLimits) {
      const countyKeys = Object.keys(loanLimits[value]);
      if (countyKeys.length > 0) {
        setCounty(countyKeys[0]);
      } else {
        setCounty("");
      }
    } else {
      setCounty("");
    }
  };

  const updateCounty = (value) => {
    setCounty(value);
  };

  const updateRural = (e) => {
    setIsRural(e.target.checked);
  };

  const updateMixedUse = (e) => {
    setIsMixedUse(e.target.checked);
  };

  // borrower

  // loan
  const [loanPurpose, setLoanPurpose] = useState(
    pickInitial(deepLinkInitial, "purpose", "Purchase", undefined),
  );
  const [loanTerm, setLoanTerm] = useState("fixed30");
  const [loanType, setLoanType] = useState(["conventional"]);
  const [propertyValue, setPropertyValue] = useState(
    pickInitial(deepLinkInitial, "housePrice", 500000, null),
  );
  const [propteryError, setPropteryError] = useState('');
  const [loanAmount, setLoanAmount] = useState(
    pickInitial(deepLinkInitial, "loanAmount", 100000, null),
  );
  const [upFrontMIP, setUpFrontMIP] = useState(() => {
    if (!deepLinkInitial?.fromDeepLink) return 400000 * 0.0175;
    if (deepLinkInitial.loanAmount != null) {
      return deepLinkInitial.loanAmount * 0.0175;
    }
    return null;
  });
  const [upFrontMIP_Financed, setUpFrontMIP_Financed] = useState(true);
  const [downPayment, setDownPayment] = useState(() => {
    if (!deepLinkInitial?.fromDeepLink) return 100000;
    const { housePrice, loanAmount } = deepLinkInitial;
    if (housePrice != null && loanAmount != null) {
      return Math.max(housePrice - loanAmount, 0);
    }
    return null;
  });
  const [secondaryLoanAmount, setSecondaryLoanAmount] = useState(0);
  const [ltv, setLtv] = useState(() => {
    if (!deepLinkInitial?.fromDeepLink) return 80;
    const { housePrice, loanAmount } = deepLinkInitial;
    if (housePrice != null && loanAmount != null) {
      return Number(((loanAmount / housePrice) * 100).toFixed(2));
    }
    return null;
  });
  const [isSubordinateLiens, setIsSubordinateLiens] = useState(false);
  const [lienType, setLienType] = useState();
  const [lienPosition, setLienPosition] = useState();
  const [helocLineAmount, setHelocLineAmount] = useState(0);
  const [helocDrawAmount, setHelocDrawAmount] = useState(0);
  const [helocLtv, setHelocLtv] = useState(0);

  // loan

  const updateLoanPurpose = (value) => {
    setLoanPurpose(value);
    if(value === "Purchase"){
      setPropertyValue(500000);
      setDownPayment(100000);
      setLoanAmount(400000);
      setUpFrontMIP(400000 * 0.0175);
      setLtv(80);
    } else {
      setPropertyValue(500000);
      setLoanAmount(100000);
      setDownPayment(400000);
      setUpFrontMIP(100000 * 0.0175);
      setLtv(20);
    }
    setPropteryError('');
  };

  const updateLoanTerm = (value) => {
    setLoanTerm(value);
  };

  const loanTypeSelect = (value) => {
    // 如果选择的是 ALL
    if (value === "") {
      setLoanType([""]);
      return;
    }
    
    // 如果当前已经选择了 ALL，则移除 ALL
    if (loanType.includes("")) {
      setLoanType([value]);
      return;
    }

    // 如果选择了所有具体选项（除了ALL），自动添加ALL
    if (loanType.length === 4 && !loanType.includes(value)) {
      setLoanType([""]);
      return;
    }

    // 其他情况正常添加
    setLoanType([...loanType, value]);
  };

  const loanTypeDeselect = (value) => {
    // 如果取消选择的是 ALL
    if (value === "") {
      setLoanType([]);
      return;
    }

    // 如果取消选择后只剩下一个选项，则添加 ALL
    if (loanType.length === 1 && loanType.includes(value)) {
      setLoanType([""]);
      return;
    }

    // 其他情况正常移除
    setLoanType(loanType.filter(item => item !== value));
  };

  const updatePropertyValue = (value) => {
    setPropertyValue(value);
    setLtv(Number(((loanPurpose === "Purchase" ? (value - downPayment) : loanAmount) / value * 100).toFixed(2)));
    if( loanPurpose === "Purchase" ){
      setLoanAmount(value - downPayment);
      setUpFrontMIP((value - downPayment) * 0.0175);
    }
    check_property_value('propertyValue', value);
  };

  const updateLoanAmount = (value) => {
    setLoanAmount(value);
    setDownPayment(propertyValue - value);
    setUpFrontMIP(value * 0.0175);
    setLtv(Number(((value) / propertyValue * 100).toFixed(2)).toFixed(2));
    check_property_value('loanAmount', value);
  };

  const updateDownPayment = (value) => {
    setDownPayment(value);
    setLoanAmount(propertyValue - value);
    setUpFrontMIP((propertyValue - value) * 0.0175);
    setLtv(Number(((propertyValue - value) / propertyValue * 100).toFixed(2)).toFixed(2));
    check_property_value('downPayment', value);
  };

  const updateSecondaryLoanAmount = (value) => {
    setSecondaryLoanAmount(value);
  };

  const updateLtv = (value) => {
    setLtv(Number(value || 0).toFixed(2));
    if(loanPurpose === "Purchase"){
      setDownPayment(Number(propertyValue) - (Number(propertyValue) * (value / 100)).toFixed(0));
      setLoanAmount((Number(propertyValue) * (value / 100)).toFixed(0));
      setUpFrontMIP((Number(propertyValue) * (value / 100)).toFixed(0) * 0.0175);
      check_property_value('downPayment', Number(propertyValue) - (Number(propertyValue) * (value / 100)));
    }else{
      setLoanAmount(Number(propertyValue) * value / 100);
      setDownPayment(Number(propertyValue) - (Number(propertyValue) * (value / 100)).toFixed(0));
      setUpFrontMIP(Number(propertyValue) * value / 100 * 0.0175);
      check_property_value('loanAmount', Number(propertyValue) * value / 100);
    }
  };

  const updateSubordinateLiens = (e) => {
    setIsSubordinateLiens(e.target.checked);
  };

  const updateLienType = (value) => {
    setLienType(value);
    if (value === "Closed_end") {
      setLienPosition("2nd");
    } else {
      setLienPosition("");
    }
  };

  const updateLienPosition = (value) => {
    setLienPosition(value);
  };

  const updateHelocLineAmount = (value) => {
    setHelocLineAmount(value);
  };

  const updateHelocDrawAmount = (value) => {
    setHelocDrawAmount(value);
  };

  const updateHelocLtv = (value) => {
    setHelocLtv(value);
  };

  // property

  const [loanLimits, setLoanLimits] = useState({});

  const getloanestimatedclosingfee = () => {
    let token = sessionStorage.getItem("ZeitroA");
    fetch("/los/getloanestimatedclosingfee", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          alert(
            "Looks like there was a problem. Status Code: " + response.status
          );
          return;
        }
        response.json().then((js) => {
          if (js.status !== "OK") {
          } else {
            let data = js.configurations;
            if (data.estimatedClosingCostsDetail) {
              setClosingFeeConfig(data.estimatedClosingCostsDetail);
            }
            if (data.lodeStarConfig) {
              setLodeStarConfig(data.lodeStarConfig);
            }
          }
        });
      })
      .catch(function (err) {});
  };

  const getLoanLimits = () => {
    fetch("/data/loanlimits")
      .then((res) => {
        if (!res.ok) {
          throw Error(res.statusText);
        }
        return res.json();
      })
      .then((res) => {
        setLoanLimits(res);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getPropertyValue = (item) => {
    return (item.loanAmount / item.LTV * 100)
  }

  // useEffect(() => {
  //   setMonthlyDebt(parseInt(monthlyIncome * dti / 100));
  // }, [monthlyIncome, dti]);

  useEffect(() => {
    getLender();
    getloanestimatedclosingfee();
    getLoanLimits();
  }, []);

  useEffect(() => {
    if (
      !fromDeepLink ||
      queryCountySyncedRef.current ||
      !deepLinkInitial?.state ||
      !deepLinkInitial?.county ||
      !loanLimits[deepLinkInitial.state]
    ) {
      return;
    }

    const matchedCounty = matchCountyInLoanLimits(
      deepLinkInitial.county,
      deepLinkInitial.state,
      loanLimits,
    );
    queryCountySyncedRef.current = true;
    if (matchedCounty) {
      setCounty(matchedCounty);
    }
  }, [loanLimits, fromDeepLink, deepLinkInitial]);

  useEffect(() => {
    // console.log("apply params to current search Fields", historyParams);

    if (historyParams === null) {
      return;
    }
    setFrom(historyParams?.from || "search");
    // apply params to current search Fields
    // loan
    setLoanPurpose(historyParams?.purpose || "");
    setLoanTerm(historyParams?.loanTerm || "");
    setLoanType(historyParams?.loanType || historyParams?.loanTypes || [""]);
    setPropertyValue(historyParams?.propertyValue || getPropertyValue(historyParams)); // 需要计算 
    setLoanAmount(historyParams?.loanAmount || 0);
    setUpFrontMIP((historyParams.loanPurpose === "Purchase" ? (historyParams.propertyValue - historyParams.downPayment) : historyParams.loanAmount) * 0.0175);
    setUpFrontMIP_Financed(historyParams?.upFrontMIP_Financed);
    setDownPayment(historyParams?.downPayment || (Number(historyParams.propertyValue - historyParams?.loanAmount )) || 0 );
    setLtv(historyParams?.LTV ? Number(historyParams?.LTV.toFixed(2)) : 0);
    setCltv(historyParams?.CLTV ? Number(historyParams?.CLTV.toFixed(2)) : 0);
    setHcltv(historyParams?.HCLTV ? Number(historyParams?.HCLTV.toFixed(2)) : 0);
    setIsSubordinateLiens(historyParams?.isSubordinateLiens || false);
    setSecondaryLoanAmount(historyParams?.secondaryLoanAmount || 0);

    // property
    setOccupancy(common.transFormOccupancy(historyParams?.occupancy) || "");
    setPropertyType(
      common.transFormPropertyType(historyParams?.property) || ""
    );
    setState(historyParams?.state || "");
    setCounty(historyParams?.county || "");
    setIsRural(historyParams?.isRural || false);
    setIsMixedUse(historyParams?.isMixedUseProperty || false); // isMixedUseProperty // isMixedUse

    // borrower
    setFico(historyParams?.FICO || 0);
    setMonthlyIncome(historyParams?.monthlyIncome || 0);
    setMonthlyDebt(historyParams?.monthlyDebt || 0);
    setDti(historyParams?.dti || 0);
    setCitizenship(historyParams?.citizenship || "US_CITIZENS");
    setIsFirstTimeHomeBuyer(historyParams?.firsttimehomebuyer || historyParams?.firstTimeHomeBuyer || false); // firsttimehomebuyer // firstTimeHomeBuyer
    setIsSelfEmployed(historyParams?.selfEmployed || historyParams?.selfemployed || false); // selfemployed // selfEmployed

    // product
    setSearchBy(historyParams?.searchBy || "price");
    setTargetPrice(historyParams.searchBy === "price" ? historyParams.targetPrice : 100  || 7);
    setTargetRate(historyParams.searchBy === "rate" ? historyParams?.targetRate || null : historyParams.targetPrice || 100); // 只记录了一个字段 用searchBy区分
    setTargetPriceType(historyParams?.targetPriceType || [""]);
    setLockDay(historyParams?.lockDay || 30);
    setCompensationType(historyParams?.compensationType || "");
    setCompensationPercent(historyParams?.compensationPercent || 0); // compensationPercentage // compensationPercent
    setEstimatedClosingFee(historyParams?.estimatedClosingCosts || 0); // estimatedClosingCosts // estimatedClosingFee
    setAusType(historyParams?.ausTypes || []);
    setBuydown(historyParams?.buyDown || "");
    setIsImpound(historyParams?.isImpound || false); // Impound  // escrowWaiver // || historyParams?.escrowWaiver
    setIsInterestOnly(historyParams?.isInterestOnly || false);
    setIsWaiveLenderFee(historyParams?.isWaiveLenderFee || false);
  }, [historyParams]);

  useEffect(() => {
    if (!closingFeeConfig) return;

    const lodeStar = lodeStarConfig || {};
    const shouldCalculate =
      lodeStar.enableCanShopServices === false &&
      lodeStar.enableTaxesAndOtherGovernmentFees === false &&
      lodeStar.enableOther === false;

    setIsCalculatedAtResults(!shouldCalculate);

    if (shouldCalculate) {
      const calculateArrayTotal = (arr) => {
        if (!arr) return 0;
        return arr.reduce(
          (sum, item) => sum + (Number(item.estimateAmount) || 0),
          0
        );
      };

      const total =
        calculateArrayTotal(closingFeeConfig.canNotShopServices) +
        calculateArrayTotal(closingFeeConfig.canShopServices) +
        calculateArrayTotal(closingFeeConfig.taxesAndOtherGovernmentFees) +
        calculateArrayTotal(closingFeeConfig.prepaids) +
        calculateArrayTotal(closingFeeConfig.initialEscrowPaymentsAtClosing) +
        calculateArrayTotal(closingFeeConfig.other) +
        calculateArrayTotal(closingFeeConfig.originationCharges);

      setEstimatedClosingFee(total);
    } else {
      setEstimatedClosingFee("Calculated at results");
    }
  }, [lodeStarConfig, closingFeeConfig]);

  // useEffect(() => {
  //   setLtv(getLTV());
  // }, [loanPurpose]);

  // useEffect(() => {
  //   setUpFrontMIP(Number(loanAmount || 0) * 0.0175);
  // }, [loanAmount]);

  const showCounties = () => {
    let options = [
    // <option value="">Select your county</option>
    ];
    if (state && state in loanLimits) {
      let keys = Object.keys(loanLimits[state]);
      keys.forEach((x) => {
        options.push(
          <option key={x} value={x}>{com.capitalize(x.replace("COUNTY", ""))}</option>
        );
      });
    }
    return options;
  };

  const closeModal_no_lender = () => {
    setIsOpen_no_lender(false);
    // console.log("closeModal_no_lender");
  };

  const loan_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M11.1337 5.33333C11.001 4.95683 10.7586 4.62864 10.4378 4.39102C10.1171 4.1534 9.73249 4.01722 9.33366 4H6.66699C6.13656 4 5.62785 4.21071 5.25278 4.58579C4.87771 4.96086 4.66699 5.46957 4.66699 6C4.66699 6.53043 4.87771 7.03914 5.25278 7.41421C5.62785 7.78929 6.13656 8 6.66699 8H9.33366C9.86409 8 10.3728 8.21071 10.7479 8.58579C11.1229 8.96086 11.3337 9.46957 11.3337 10C11.3337 10.5304 11.1229 11.0391 10.7479 11.4142C10.3728 11.7893 9.86409 12 9.33366 12H6.66699C6.26816 11.9828 5.8836 11.8466 5.56281 11.609C5.24203 11.3714 4.99969 11.0432 4.86699 10.6667M8.00033 2V4M8.00033 12V14"
          stroke="#1630AC"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const property_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M2.55556 8H1L8 1L15 8H13.4444"
          stroke="#1630AC"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.55556 8V13.4444C2.55556 13.857 2.71944 14.2527 3.01117 14.5444C3.30289 14.8361 3.69855 15 4.11111 15H11.8889C12.3014 15 12.6971 14.8361 12.9888 14.5444C13.2806 14.2527 13.4444 13.857 13.4444 13.4444V8"
          stroke="#1630AC"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.44444 8H9.55556V11.1111H6.44444V8Z"
          stroke="#1630AC"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const borrower_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M4 14V12.6667C4 11.9594 4.28095 11.2811 4.78105 10.781C5.28115 10.281 5.95942 10 6.66667 10H9.33333C10.0406 10 10.7189 10.281 11.219 10.781C11.719 11.2811 12 11.9594 12 12.6667V14M5.33333 4.66667C5.33333 5.37391 5.61428 6.05219 6.11438 6.55229C6.61448 7.05238 7.29276 7.33333 8 7.33333C8.70724 7.33333 9.38552 7.05238 9.88562 6.55229C10.3857 6.05219 10.6667 5.37391 10.6667 4.66667C10.6667 3.95942 10.3857 3.28115 9.88562 2.78105C9.38552 2.28095 8.70724 2 8 2C7.29276 2 6.61448 2.28095 6.11438 2.78105C5.61428 3.28095 5.33333 3.95942 5.33333 4.66667Z"
          stroke="#1630AC"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const product_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.0918 3.50059C7.0918 2.58932 7.83396 1.85059 8.74947 1.85059H9.2518C10.1673 1.85059 10.9095 2.58932 10.9095 3.50059V9.83392C10.9095 10.7452 10.1673 11.4839 9.2518 11.4839H8.74947C7.83396 11.4839 7.0918 10.7452 7.0918 9.83392V3.50059ZM8.74947 3.15059C8.55527 3.15059 8.39784 3.30729 8.39784 3.50059V9.83392C8.39784 10.0272 8.55527 10.1839 8.74947 10.1839H9.2518C9.446 10.1839 9.60342 10.0272 9.60342 9.83392V3.50059C9.60342 3.30729 9.446 3.15059 9.2518 3.15059H8.74947Z"
          fill="#1630AC"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.31934 6.00059C2.31934 5.08932 3.0615 4.35059 3.97701 4.35059H4.47934C5.39484 4.35059 6.13701 5.08932 6.13701 6.00059V10.0006C6.13701 10.9119 5.39484 11.6506 4.47934 11.6506H3.97701C3.0615 11.6506 2.31934 10.9119 2.31934 10.0006V6.00059ZM3.97701 5.65059C3.78281 5.65059 3.62538 5.80729 3.62538 6.00059V10.0006C3.62538 10.1939 3.78281 10.3506 3.97701 10.3506H4.47934C4.67353 10.3506 4.83096 10.1939 4.83096 10.0006V6.00059C4.83096 5.80729 4.67353 5.65059 4.47934 5.65059H3.97701Z"
          fill="#1630AC"
        />
        <rect
          x="16.0322"
          y="12.5"
          width="1.335"
          height="14.0651"
          rx="0.6675"
          transform="rotate(90 16.0322 12.5)"
          fill="#1630AC"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.8643 7.50059C11.8643 6.58932 12.6064 5.85059 13.5219 5.85059H14.0243C14.9398 5.85059 15.6819 6.58932 15.6819 7.50059V10.0006C15.6819 10.9119 14.9398 11.6506 14.0243 11.6506H13.5219C12.6064 11.6506 11.8643 10.9119 11.8643 10.0006V7.50059ZM13.5219 7.15059C13.3277 7.15059 13.1703 7.30729 13.1703 7.50059V10.0006C13.1703 10.1939 13.3277 10.3506 13.5219 10.3506H14.0243C14.2185 10.3506 14.3759 10.1939 14.3759 10.0006V7.50059C14.3759 7.30729 14.2185 7.15059 14.0243 7.15059H13.5219Z"
          fill="#1630AC"
        />
      </svg>
    );
  };

  const question_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M7 0.00330764C5.20252 -0.0545737 3.45674 0.649163 2.14481 1.96047C0.832876 3.27178 0.0616697 5.08384 0 7C0.0616697 8.91616 0.832876 10.7282 2.14481 12.0395C3.45674 13.3508 5.20252 14.0546 7 13.9967C8.79748 14.0546 10.5433 13.3508 11.8552 12.0395C13.1671 10.7282 13.9383 8.91616 14 7C13.9383 5.08384 13.1671 3.27178 11.8552 1.96047C10.5433 0.649163 8.79748 -0.0545737 7 0.00330764ZM7 12.8306C5.49252 12.8886 4.02483 12.3078 2.91799 11.2152C1.81114 10.1225 1.15523 8.60693 1.09375 7C1.15523 5.39307 1.81114 3.87751 2.91799 2.78485C4.02483 1.69218 5.49252 1.11135 7 1.16942C8.50747 1.11135 9.97517 1.69218 11.082 2.78485C12.1889 3.87751 12.8448 5.39307 12.9062 7C12.8448 8.60693 12.1889 10.1225 11.082 11.2152C9.97517 12.3078 8.50747 12.8886 7 12.8306Z"
          fill="#586570"
        />
        <path
          d="M7.02836 10.461C7.42048 10.461 7.73836 10.1435 7.73836 9.75197C7.73836 9.3604 7.42048 9.04297 7.02836 9.04297C6.63624 9.04297 6.31836 9.3604 6.31836 9.75197C6.31836 10.1435 6.63624 10.461 7.02836 10.461Z"
          fill="#586570"
        />
        <path
          d="M8.51312 3.97133C8.07969 3.6172 7.54523 3.43274 6.99937 3.44891C6.73589 3.43256 6.47199 3.47211 6.22294 3.56527C5.9739 3.65844 5.74467 3.80336 5.54854 3.99165C5.3524 4.17994 5.19326 4.40785 5.08032 4.66218C4.96739 4.91651 4.90291 5.1922 4.89062 5.47328V5.5759H5.97562V5.48261C5.99362 5.21038 6.11081 4.95647 6.30212 4.77516C6.49344 4.59385 6.74369 4.49954 6.99937 4.5124C7.12278 4.4965 7.24795 4.50881 7.36654 4.54851C7.48514 4.58822 7.59444 4.65441 7.68716 4.74267C7.77989 4.83094 7.8539 4.93925 7.90429 5.06041C7.95468 5.18156 7.98027 5.31277 7.97937 5.4453C7.97937 5.77181 7.76937 6.12631 7.29688 6.48081C7.0628 6.62105 6.86212 6.81684 6.71039 7.05302C6.55866 7.28921 6.45994 7.55945 6.42187 7.84283V8.17867H7.50687V7.93612C7.51478 7.75601 7.58674 7.58588 7.70813 7.46034C7.84642 7.29352 7.99872 7.14051 8.16312 7.00323L8.31187 6.87262C8.55546 6.70381 8.75579 6.473 8.8948 6.20102C9.03381 5.92904 9.10713 5.62443 9.10812 5.31469C9.10903 5.05767 9.05608 4.80367 8.95314 4.57126C8.8502 4.33884 8.69987 4.13388 8.51312 3.97133Z"
          fill="#586570"
        />
      </svg>
    );
  };

  const edit_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.96245 3.47627C2.77885 3.47627 2.60278 3.5492 2.47296 3.67902C2.34314 3.80884 2.27021 3.98491 2.27021 4.1685V13.8598C2.27021 14.0434 2.34314 14.2195 2.47296 14.3493C2.60278 14.4791 2.77885 14.552 2.96245 14.552H12.6537C12.8373 14.552 13.0134 14.4791 13.1432 14.3493C13.273 14.2195 13.346 14.0434 13.346 13.8598V11.0909C13.346 10.7085 13.6559 10.3986 14.0382 10.3986C14.4205 10.3986 14.7304 10.7085 14.7304 11.0909V13.8598C14.7304 14.4106 14.5116 14.9388 14.1222 15.3282C13.7327 15.7177 13.2045 15.9365 12.6537 15.9365H2.96245C2.41167 15.9365 1.88345 15.7177 1.49399 15.3282C1.10454 14.9388 0.885742 14.4106 0.885742 13.8598V4.1685C0.885742 3.61773 1.10454 3.08951 1.49399 2.70005C1.88345 2.31059 2.41167 2.0918 2.96245 2.0918H5.73139C6.1137 2.0918 6.42362 2.40172 6.42362 2.78403C6.42362 3.16634 6.1137 3.47627 5.73139 3.47627H2.96245Z"
          fill="#325CEB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.0257 0.910759C12.2961 0.640424 12.7343 0.640424 13.0047 0.910759L15.9121 3.81814C16.1814 4.08748 16.1825 4.5238 15.9146 4.79454L9.3384 11.44C9.21586 11.5638 9.05113 11.6369 8.87709 11.6446L5.76203 11.7831C5.56529 11.7918 5.37413 11.7164 5.23642 11.5756C5.09872 11.4348 5.0275 11.242 5.0406 11.0455L5.24827 7.93043C5.25942 7.76312 5.33092 7.60555 5.44949 7.48699L12.0257 0.910759ZM12.5152 2.37921L6.61237 8.28204L6.47346 10.3656L8.54492 10.2736L14.4462 4.31018L12.5152 2.37921Z"
          fill="#325CEB"
        />
      </svg>
    );
  };

  // 添加新的状态变量
  const [cltv, setCltv] = useState(0);
  const [hcltv, setHcltv] = useState(0);

  // 添加新的更新函数
  const updateCltv = (value) => {
    setCltv(value);
  };

  const updateHcltv = (value) => {
    setHcltv(value);
  };

  const getLTV = () => {
    console.log('getLTV', loanPurpose, propertyValue, downPayment)
    // let loanAmount = 0;
    // if (loanPurpose == "Purchase") {
    //   loanAmount = parseInt(propertyValue) - parseInt(downPayment);
    // } else {
    //   loanAmount = parseInt(downPayment);
    // }
    return Number(((loanAmount / parseInt(propertyValue)) * 100).toFixed(2));
  };

  const mixedUseTooltip = () => {
    return (
      <div>
        <p><span style={{ cursor: 'pointer', textDecoration: 'underline'}} onClick={() => {
          window.open('https://www.consumerfinance.gov/rural-or-underserved-tool/', '_blank');
        }}>click to check</span> if the property is mixed use</p>
      </div>
    );
  };

  const field_Loan = () => {
    return (
      <div className="search-fields-content-item loan_field">
        <div className="search-fields-content-item-title">
          <div className="search-fields-content-item-title-svg">
            {loan_svg()}
          </div>
          <span className="search-fields-content-item-title-text">Loan</span>
        </div>
        <div className="search-fields-content-item-content">
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Loan purpose
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select"
                value={loanPurpose}
                onChange={updateLoanPurpose}
              >
                <option value="Purchase">Purchase</option>
                <option value="RateTermRefi">Refinance</option>
                <option value="CashOutRefi">Cash Out</option>
              </Select>
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Loan term
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select"
                value={loanTerm}
                onChange={updateLoanTerm}
              >
                {propertyType !== "manufacturedhome" && (
                  <option value="fixed30">Fixed 30 Year</option>
                )}
                <option value="fixed25">Fixed 25 Year</option>
                <option value="fixed20">Fixed 20 Year</option>
                <option value="fixed15">Fixed 15 Year</option>
                <option value="fixed10">Fixed 10 Year</option>
                <option value="arm56">ARM 5/6</option>
                <option value="arm76">ARM 7/6</option>
                <option value="arm106">ARM 10/6</option>
              </Select>
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Loan type
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select"
                mode="multiple"
                maxTagCount={1}
                maxTagPlaceholder={() => 
                  loanType.length > 1
                  ? "+" + (loanType.length - 1)
                  : ""
                }
                value={loanType}
                onSelect={loanTypeSelect}
                onDeselect={loanTypeDeselect}
              >
                <option value="">ALL</option>
                <option value="fha">FHA</option>
                <option value="va">VA</option>
                <option value="conventional">Conventional</option>
                <option value="usda">USDA-RD</option>
                <option value="other">Other</option>
              </Select>
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              {loanPurpose === "Purchase" ? "Property value" : "Home value"}
            </div>
            <div className="search-fields-content-item-content-item-select"  style={{display: 'flex', flexDirection: 'column'}}>
              <InputNumber
                prefix="$"
                style={{ width: "100%", borderRadius: 6, height: 44 }}
                placeholder="Input"
                value={propertyValue}
                onChange={updatePropertyValue}
                status={propteryError ? "error" : ""}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              />
              {propteryError && (
                <div style={{ color: "#C21818", fontSize: "14px", marginTop: "4px", width: "100%", textAlign: "left" }}>
                  {propteryError}
                </div>
              )}
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              <div style={{ display: "flex", width: "100%" }}>
                <span style={{ flex: 2 }}>
                  {loanPurpose === "Purchase"
                    ? "Down payment（1st）"
                    : "Loan amount（1st）"}
                </span>
                <span style={{ flex: 1 }}>LTV</span>
              </div>
            </div>
            <div
              className="search-fields-content-item-content-item-select"
              style={{
                display: "flex",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                overflow: "hidden",
              }}
            >
              {loanPurpose === "Purchase" ? (
                <InputNumber
                  style={{ flex: 2, border: "none", borderRadius: 0, height: 44 }}
                  prefix="$"
                  placeholder="Down payment"
                  value={downPayment}
                  onChange={updateDownPayment}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                />
              ) : (
                <InputNumber
                  style={{ flex: 2, border: "none", borderRadius: 0, height: 44 }}
                  prefix="$"
                  placeholder="Loan amount"
                  value={loanAmount}
                  onChange={updateLoanAmount}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                />
              )}
              <div
                style={{
                  width: "1px",
                  height: "34px",
                  backgroundColor: "#d9d9d9",
                }}
              ></div>
              <InputNumber
                style={{
                  flex: 1,
                  border: "none",
                  borderRadius: 0,
                  height: 44
                }}
                placeholder="LTV"
                suffix="%"
                value={ltv}
                onChange={updateLtv}
              />
            </div>
          </div>

          {(loanType.includes("fha") || loanType.includes("")) && 
          <>
            <div className="search-fields-content-item-content-item">
              <div className="search-fields-content-item-content-item-title">
                Upfront Mortgage Insurance Premium (UFMIP) 
              </div>
              <div className="search-fields-content-item-content-item-select">
                <InputNumber
                  disabled={true}
                  prefix="$"
                  style={{ width: "100%", borderRadius: 6, height: 44 }}
                  placeholder="Input"
                  value={upFrontMIP}
                  // onChange={() => {}}
                  formatter={(value) => Number(value || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                />
              </div>
            </div>

            <div className="search-fields-content-item-content-item">
              <div className="search-fields-content-item-content-item-select">
                <Checkbox
                  checked={upFrontMIP_Financed}
                  onChange={() => {
                    setUpFrontMIP_Financed(!upFrontMIP_Financed);
                  }}
                >
                  UFMIP Financed?
                </Checkbox>
              </div>
            </div>
          </>
          }

          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Secondary loan amount
            </div>
            <div className="search-fields-content-item-content-item-select">
              <InputNumber
                prefix="$"
                style={{ width: "100%", borderRadius: 6, height: 44 }}
                placeholder="Input"
                value={secondaryLoanAmount}
                onChange={updateSecondaryLoanAmount}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              />
            </div>
          </div>

          {/* do not show and do not remove*/}
          {/* <div className="search-fields-content-item-content-item">
            <Checkbox
              checked={isSubordinateLiens}
              onChange={updateSubordinateLiens}
            >
              Subordinate Liens
            </Checkbox>
          </div> */}
          {/* 根据 Subordinate Liens 是否勾选决定是否显示 */}
          {/* {isSubordinateLiens && (
            <>
              <div className="search-fields-content-item-content-item">
                <div className="search-fields-content-item-content-item-title">
                  <span style={{flex: 1}}>Lien type</span>
                  <span style={{flex: 1}}>Position</span>
                </div>
                <div className="search-fields-content-item-content-item-select" style={{display: "flex", width: "100%", border: "1px solid #d9d9d9", borderRadius: "6px", overflow: "hidden"}}>
                  <Select
                    style={{ flex: 1, borderRadius: 0, border: "none" }}
                    className="borderNoneSelect"
                    type="text"
                    placeholder="Select"
                    value={lienType}
                    onChange={updateLienType}
                  >
                    <option value="HELOC">HELOC</option>
                    <option value="HELOAN">HELOAN</option>
                    <option value="Closed_end">Closed End</option>
                  </Select>
                  <div style={{width: "1px", height: "34px", backgroundColor: "#d9d9d9"}}></div>
                  <Select
                    style={{ flex: 1, borderRadius: 0, border: "none" }}
                    className="borderNoneSelect"
                    type="text"
                    placeholder="Select"
                    value={lienPosition}
                    onChange={updateLienPosition}
                  >
                    <option value="1st" disabled={lienType === "Closed_end"}>1st</option>
                    <option value="2nd">2nd</option>
                  </Select>
                </div>
              </div>
              {lienType === "HELOC" && lienPosition !== "" && (
                <>
                  <div className="search-fields-content-item-content-item">
                    <div className="search-fields-content-item-content-item-title">
                      {lienPosition === "2nd" ? (
                        "HELOC Line amount (2nd)"
                      ) : (
                        <div style={{display: "flex", width: "100%"}}>
                          <span style={{flex: 2}}>HELOC Line amount (1st)</span>
                          <span style={{flex: 1}}>LTV</span>
                        </div>
                      )}
                    </div>
                    <div
                      className="search-fields-content-item-content-item-select"
                      style={{
                        display: "flex",
                        border: "1px solid #d9d9d9",
                        borderRadius: "6px",
                        overflow: "hidden",
                      }}
                    >
                      <Input
                        style={{
                          flex: lienPosition === "1st" ? 2 : 1,
                          border: "none",
                          borderRadius: 0,
                        }}
                        prefix="$"
                        type="text"
                        placeholder="HELOC Line amount"
                        value={helocLineAmount}
                        onChange={updateHelocLineAmount}
                      />
                      {lienPosition === "1st" && (
                        <>
                          <div
                            style={{
                              width: "1px",
                              height: "34px",
                              backgroundColor: "#d9d9d9",
                            }}
                          ></div>
                          <Input
                            style={{
                              flex: 1,
                              border: "none",
                              borderRadius: 0,
                            }}
                            type="text"
                            placeholder="LTV"
                            suffix="%"
                            value={helocLtv}
                            onChange={updateHelocLtv}
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="search-fields-content-item-content-item">
                    <div className="search-fields-content-item-content-item-title">
                      HELOC draw amount
                    </div>
                    <div className="search-fields-content-item-content-item-select">
                      <Input
                        prefix="$"
                        type="text"
                        placeholder="HELOC draw amount"
                        value={helocDrawAmount}
                        onChange={updateHelocDrawAmount}
                      />
                    </div>
                  </div>
                </>
              )}
              {lienType === "HELOAN" && lienPosition !== "" && (
                <div className="search-fields-content-item-content-item">
                  <div className="search-fields-content-item-content-item-title">
                    <div style={{display: "flex", width: "100%"}}>
                      <span style={{flex: lienPosition === "1st" ? 2 : 1}}>Lien amount ({lienPosition === "1st" ? "1st" : "2nd"})</span>
                      {lienPosition === "1st" && <span style={{flex: 1}}>LTV</span>}
                    </div>
                  </div>
                  <div
                    className="search-fields-content-item-content-item-select"
                    style={{
                      display: "flex",
                      border: "1px solid #d9d9d9",
                      borderRadius: "6px",
                      overflow: "hidden",
                    }}
                  >
                    <Input
                      style={{
                        flex: lienPosition === "1st" ? 2 : 1,
                        border: "none",
                        borderRadius: 0,
                      }}
                      prefix="$"
                      type="text"
                      placeholder="Lien amount"
                      value={helocLineAmount}
                      onChange={updateHelocLineAmount}
                    />
                    {lienPosition === "1st" && (
                      <>
                        <div
                          style={{
                            width: "1px",
                            height: "34px",
                            backgroundColor: "#d9d9d9",
                          }}
                        ></div>
                        <Input
                          style={{
                            flex: 1,
                            border: "none",
                            borderRadius: 0,
                          }}
                          type="text"
                          placeholder="LTV"
                          suffix="%"
                          value={helocLtv}
                          onChange={updateHelocLtv}
                        />
                      </>
                    )}
                  </div>
                </div>
              )}
              {lienType === "Closed_end" && lienPosition !== "" && (
                <div className="search-fields-content-item-content-item">
                  <div className="search-fields-content-item-content-item-title">
                    Lien amount (2nd)
                  </div>
                  <div className="search-fields-content-item-content-item-select">
                    <Input
                      prefix="$"
                      type="text"
                      placeholder="Lien amount"
                    />
                  </div>
                </div>
              )}
            </>
          )}
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              LTV / CLTV / HCLTV
            </div>
            <div
              className="search-fields-content-item-content-item-select"
              style={{
                display: "flex",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                overflow: "hidden",
              }}
            >
              <InputNumber
                style={{
                  flex: 1,
                  border: "none",
                  borderRadius: 0,
                }}
                type="number"
                placeholder="LTV"
                suffix="%"
                value={ltv}
                onChange={updateLtv}
              />
              <div
                style={{
                  width: "1px",
                  height: "34px",
                  backgroundColor: "#d9d9d9",
                }}
              ></div>
              <InputNumber
                style={{
                  flex: 1,
                  border: "none",
                  borderRadius: 0,
                }}
                type="number"
                placeholder="CLTV"
                suffix="%"
                value={cltv}
                onChange={updateCltv}
              />
              <div
                style={{
                  width: "1px",
                  height: "34px",
                  backgroundColor: "#d9d9d9",
                }}
              ></div>
              <InputNumber
                style={{
                  flex: 1,
                  border: "none",
                  borderRadius: 0,
                }}
                type="number"
                placeholder="HCLTV"
                suffix="%"
                value={hcltv}
                onChange={updateHcltv}
              />
            </div>
          </div> */}
        </div>
      </div>
    );
  };
  const field_Property = () => {
    return (
      <div className="search-fields-content-item property_field">
        <div className="search-fields-content-item-title">
          <div className="search-fields-content-item-title-svg">
            {property_svg()}
          </div>
          <span className="search-fields-content-item-title-text">
            Property
          </span>
        </div>
        <div className="search-fields-content-item-content">
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Occupancy
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select"
                value={occupancy}
                onChange={updateOccupancy}
              >
                <option value="principal">Primary Residence</option>
                <option value="secondhome">Second Home</option>
                <option value="investment">Investment</option>
              </Select>
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Property Type
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select"
                value={propertyType}
                onChange={updatePropertyType}
              >
                <option value="singlefamilydetached">
                  Single Family Home, Detached
                </option>
                <option value="singlefamilyattached">
                  Single Family Home, Attached
                </option>
                <option value="condominiumdetached">
                  Condominium, Detached
                </option>
                <option value="condominium">Condominium, Attached</option>
                <option value="pudattached">
                  Planned Unit Development, attached
                </option>
                <option value="puddetached">
                  Planned Unit Development, detached
                </option>
                <option value="twotofourfamily">2 to 4 Unit Multifamily</option>
                <option value="manufacturedhome">Manufactured Home</option>
              </Select>
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              State
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select"
                value={state}
                onChange={updateState}
              >
                <option value="ALABAMA">Alabama</option>
                <option value="ALASKA">Alaska</option>
                <option value="ARIZONA">Arizona</option>
                <option value="ARKANSAS">Arkansas</option>
                <option value="CALIFORNIA">California</option>
                <option value="COLORADO">Colorado</option>
                <option value="CONNECTICUT">Connecticut</option>
                <option value="DELAWARE">Delaware</option>
                <option value="FLORIDA">Florida</option>
                <option value="GEORGIA">Georgia</option>
                <option value="HAWAII">Hawaii</option>
                <option value="IDAHO">Idaho</option>
                <option value="ILLINOIS">Illinois</option>
                <option value="INDIANA">Indiana</option>
                <option value="IOWA">Iowa</option>
                <option value="KANSAS">Kansas</option>
                <option value="KENTUCKY">Kentucky</option>
                <option value="LOUISIANA">Louisiana</option>
                <option value="MAINE">Maine</option>
                <option value="MARYLAND">Maryland</option>
                <option value="MASSACHUSETTS">Massachusetts</option>
                <option value="MICHIGAN">Michigan</option>
                <option value="MINNESOTA">Minnesota</option>
                <option value="MISSISSIPPI">Mississippi</option>
                <option value="MISSOURI">Missouri</option>
                <option value="MONTANA">Montana</option>
                <option value="NEBRASKA">Nebraska</option>
                <option value="NEVADA">Nevada</option>
                <option value="NEW HAMPSHIRE">New Hampshire</option>
                <option value="NEW JERSEY">New Jersey</option>
                <option value="NEW MEXICO">New Mexico</option>
                <option value="NEW YORK">New York</option>
                <option value="NORTH CAROLINA">North Carolina</option>
                <option value="NORTH DAKOTA">North Dakota</option>
                <option value="OHIO">Ohio</option>
                <option value="OKLAHOMA">Oklahoma</option>
                <option value="OREGON">Oregon</option>
                <option value="PENNSYLVANIA">Pennsylvania</option>
                <option value="RHODE ISLAND">Rhode Island</option>
                <option value="SOUTH CAROLINA">South Carolina</option>
                <option value="SOUTH DAKOTA">South Dakota</option>
                <option value="TENNESSEE">Tennessee</option>
                <option value="TEXAS">Texas</option>
                <option value="UTAH">Utah</option>
                <option value="VERMONT">Vermont</option>
                <option value="VIRGINIA">Virginia</option>
                <option value="WASHINGTON">Washington</option>
                <option value="WEST VIRGINIA">West Virginia</option>
                <option value="WISCONSIN">Wisconsin</option>
                <option value="WYOMING">Wyoming</option>
              </Select>
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              County
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select county"
                value={county}
                onChange={updateCounty}
              >
                {showCounties()}
              </Select>
            </div>
          </div>
          {/* <div className="search-fields-content-item-content-item">
            <Checkbox checked={isRural} onChange={updateRural}>
              Rural
              {
                <Tooltip title="Click to check if the property qualifies as rural">
                  <span className="search-fields-content-item-content-item-svg">
                    {question_svg()}
                  </span>
                </Tooltip>
              }
            </Checkbox>
            <Checkbox checked={isMixedUse} onChange={updateMixedUse}>
              Mixed Use
              {
                <Tooltip title={mixedUseTooltip()}>
                  <span className="search-fields-content-item-content-item-svg">
                    {question_svg()}
                  </span>
                </Tooltip>
              }
            </Checkbox>
          </div> */}
        </div>
      </div>
    );
  };
  const field_Borrower = () => {
    return (
      <div className="search-fields-content-item borrower_field">
        <div className="search-fields-content-item-title">
          <div className="search-fields-content-item-title-svg">
            {borrower_svg()}
          </div>
          <span className="search-fields-content-item-title-text">
            Borrower
          </span>
        </div>
        <div className="search-fields-content-item-content">
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Est FICO
            </div>
            <div 
              className="search-fields-content-item-content-item-select" 
              style={{
                display: "flex",
                flexDirection: "column",
              }}>
              <InputNumber
                suffix=" "
                style={{ width: "100%", height: 44, borderRadius: 6, border: ficoError ? "1px solid #C21818" : "1px solid #d9d9d9" }}
                placeholder="Input"
                value={fico}
                onChange={updateFico}
                onBlur={() => {}}
                status={ficoError ? "error" : ""}
              />
              {ficoError && (
                <div style={{ color: "#C21818", fontSize: "14px", marginTop: "4px", width: "100%", textAlign: "left" }}>
                  {ficoError}
                </div>
              )}
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Monthly income
            </div>
            <div className="search-fields-content-item-content-item-select">
              <InputNumber
                prefix="$"
                style={{ width: "100%", height: 44 }}
                placeholder="Input"
                value={monthlyIncome}
                onChange={updateMonthlyIncome}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              />
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              <div style={{ display: "flex", width: "100%" }}>
                <span style={{ flex: 2 }}>Monthly debt</span>
                <span style={{ flex: 1 }}>DTI</span>
              </div>
            </div>
            <div
              className="search-fields-content-item-content-item-select"
              style={{
                display: "flex",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                overflow: "hidden",
              }}
            >
              <InputNumber
                style={{ flex: 2, border: "none", borderRadius: 0, height: 44 }}
                prefix="$"
                placeholder="Monthly debt"
                value={monthlyDebt}
                onChange={updateMonthlyDebt}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              />
              {/* <div
                style={{
                  width: "1px",
                  height: "34px",
                  backgroundColor: "#d9d9d9",
                }}
              ></div> */}
              <InputNumber
                style={{ flex: 1, border: "none", borderRadius: 0, height: 44 }}
                disabled
                placeholder="DTI"
                suffix="%"
                value={dti}
                onChange={updateDti}
              />
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Citizenship
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select"
                value={citizenship}
                onChange={updateCitizenship}
              >
                <option value="US_CITIZENS">US Citizen</option>
                <option value="PERMANENT_RESIDENT_ALIEN">
                  Permanent Resident Alien
                </option>
                <option value="NON_RESIDENT_ALIEN">Non Resident Alien</option>
              </Select>
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <Checkbox
              checked={isFirstTimeHomeBuyer}
              onChange={updateFirstTimeHomeBuyer}
            >
              First time home buyer
            </Checkbox>
          </div>
          <div className="search-fields-content-item-content-item">
            <Checkbox checked={isSelfEmployed} onChange={updateSelfEmployed}>
              Self employed
            </Checkbox>
          </div>
        </div>
      </div>
    );
  };

  const handleEditCompensation = () => {
    setAddLenderModal(true);
  };

  const handleEditCompensationModal = () => {
    console.log("handleEditCompensationModal");
  };

  const reset_all = () => {
    // loan
    setLoanPurpose("Purchase");
    setLoanTerm("fixed30");
    setLoanType(["conventional"]);
    setPropertyValue(500000);
    setDownPayment(100000);
    setLoanAmount(100000);
    setUpFrontMIP(400000 * 0.0175);
    setUpFrontMIP_Financed(true);
    setSecondaryLoanAmount(0);
    setLtv(80);
    setIsSubordinateLiens(false);
    setLienType();
    setLienPosition();
    setHelocLineAmount(0);
    setHelocDrawAmount(0);
    setHelocLtv(0);
    setCltv(0);
    setHcltv(0);

    // property
    setOccupancy("principal");
    setPropertyType("singlefamilydetached");
    setState("CALIFORNIA");
    setCounty("ALAMEDA COUNTY");
    setIsRural(false);
    setIsMixedUse(false);

    // borrower
    setFico(780);
    setMonthlyIncome(10000);
    setMonthlyDebt(1000);
    setDti(10);
    setCitizenship("US_CITIZENS");
    setIsFirstTimeHomeBuyer(true);
    setIsSelfEmployed(false);

    // product
    setSearchBy("price");
    setTargetPrice(100);
    setTargetRate(null);
    setTargetPriceType([""]);
    setLockDay(30);
    setCompensationType("lender_paid");
    setCompensationPercent(0);
    setEstimatedClosingFee(0);
    setAusType();
    setBuydown();
    setIsImpound(true);
    setIsInterestOnly(false);
    setIsWaiveLenderFee(false);

    // reset error
    setPropteryError('');
    setFicoError('');
  };

  const updateSearchBy = (value) => {
    setSearchBy(value);
    setTargetRateMessage('');
    if(value === 'rate'){
      setTargetRate(null);
    }
  };

  const updateTargetRate = (value) => {
    if(value === null){
      setTargetRateMessage('Please enter target rate');
      // return;
    }else if(value < 0 || value > 20){
      setTargetRateMessage('Target rate must be between 0 and 20');
      // return;
    }else{
      setTargetRateMessage('');
    }
    setTargetRate(value);
  };

  const field_Product = () => {
    return (
      <div className="search-fields-content-item product_field">
        <div className="search-fields-content-item-title">
          <div className="search-fields-content-item-title-svg">
            {product_svg()}
          </div>
          <span className="search-fields-content-item-title-text">Product</span>
        </div>
        <div className="search-fields-content-item-content">
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Search by
            </div>
            <div
              className="search-fields-content-item-content-item-select"
              style={{
                display: "flex",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                overflow: "hidden",
              }}
            >
              <Select
                style={{
                  flex: 1,
                  border: "none",
                  borderRadius: 0,
                }}
                className="borderNoneSelect"
                type="text"
                placeholder="Select"
                value={searchBy}
                onChange={updateSearchBy}
              >
                <option value="price">Price (Base 100)</option>
                <option value="rate">Rate</option>
              </Select>
            </div>
          </div>
          {searchBy === "price" && (
            <div className="search-fields-content-item-content-item">
              <div className="search-fields-content-item-content-item-title">
                Target price (Base 100)
                <span className="search-fields-content-item-content-item-svg cursor-pointer">
                  <Tooltip title="This filter helps identify rates matching your target lender pricing by calculating the current target price from the sum of lock point, adjustment point, compensation point">
                    {question_svg()}
                  </Tooltip>
                </span>
              </div>
              <div
                className="search-fields-content-item-content-item-select"
                style={{
                  display: "flex",
                  border: targetRateMessage ? "1px solid #C21818" : "1px solid #d9d9d9",
                  borderRadius: "6px",
                  overflow: "hidden",
                }}
              >
                <InputNumber
                  suffix=" "
                  style={{ flex: 1, border: "none", borderRadius: 0, height: 44 }}
                  // min={searchBy === "price" ? 80 : 0}
                  // max={searchBy === "price" ? 120 : 20}
                  type="number"
                  placeholder="Enter target price"
                  value={targetPrice}
                  status={targetRateMessage ? "error" : ""}
                  onChange={updateTargetPrice}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                />
                <div
                  style={{
                    width: "1px",
                    height: "34px",
                    backgroundColor: "#d9d9d9",
                  }}
                ></div>
                <Select
                  style={{
                    flex: 2,
                    border: "none",
                    borderRadius: 0,
                  }}
                  className="borderNoneSelect"
                  type="text"
                  placeholder="Select"
                  mode="multiple"
                  maxTagCount={1}
                  maxTagPlaceholder={() =>
                    targetPriceType.length > 1
                      ? "+" + (targetPriceType.length - 1)
                      : ""
                  }
                  maxTagTextLength={4}
                  value={targetPriceType}
                  onChange={updateTargetPriceType}
                >
                  <option value="">ALL</option>
                  <option value="lockpoint">Lock point</option>
                  <option value="adjustment">Adjustment</option>
                  <option value="compensation">Compensation</option>
                </Select>
              </div>
              {targetRateMessage && <div style={{ color: "#C21818", fontSize: "14px", marginTop: "4px", width: "100%", textAlign: "left" }}>{targetRateMessage}</div>}
            </div>
          )}
          {searchBy === "rate" && (
            <div className="search-fields-content-item-content-item">
              <div className="search-fields-content-item-content-item-title">
                Target rate
              </div>
              <div
                className="search-fields-content-item-content-item-select"
                style={{
                  display: "flex",
                  border: targetRateMessage ? "1px solid #C21818" : "1px solid #d9d9d9",
                  borderRadius: "6px",
                  overflow: "hidden",
                }}
              >
                <InputNumber
                  // min={0}
                  // max={20}
                  style={{ flex: 1, border: "none", borderRadius: 0, height: 44 }}
                  type="number"
                  placeholder="Enter target rate"
                  suffix="%"
                  value={targetRate}
                  status={targetRateMessage ? "error" : ""}
                  onChange={updateTargetRate}
                />
              </div>
              {targetRateMessage && <div style={{ color: "#C21818", fontSize: "14px", marginTop: "4px", width: "100%", textAlign: "left" }}>{targetRateMessage}</div>}
            </div>
          )}
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Lock days
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select"
                value={lockDay}
                onChange={updateLockDay}
              >
                <option value="15">15</option>
                <option value="30">30</option>
                <option value="45">45</option>
                <option value="60">60</option>
                <option value="75">75</option>
              </Select>
            </div>
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Compensation
              {/* <span
                className="search-fields-content-item-content-item-svg cursor-pointer"
                onClick={handleEditCompensation}
              >
                {edit_svg()}
              </span> */}
            </div>
            <div
              className="search-fields-content-item-content-item-select"
              style={{
                display: "flex",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                overflow: "hidden",
              }}
            >
              <Select
                style={{
                  flex: 2,
                  border: "none",
                  borderRadius: 0,
                }}
                className="borderNoneSelect"
                type="text"
                placeholder="Select"
                value={compensationType}
                onChange={updateCompensationType}
              >
                <option value="lender_paid">Lender paid</option>
                <option value="borrower_paid">Borrower paid</option>
              </Select>
              {compensationType !== "lender_paid" && <div
                style={{
                  width: "1px",
                  height: "34px",
                  backgroundColor: "#d9d9d9",
                }}
              ></div>}
              {compensationType !== "lender_paid" && <InputNumber
                style={{ flex: 1, border: "none", borderRadius: 0, height: 44 }}
                disabled={compensationType === "lender_paid"}
                placeholder="Input"
                suffix="%"
                value={compensationPercent}
                onChange={updateCompensationPercent}
              />}
            </div>
            {compensationType === "lender_paid" && !checkAccess([UR_Owner]) &&
              <div style={{ color: "#6E6E70", fontSize: 14, marginTop: 8, width: "100%", textAlign: "left", fontWeight: 400 }}>
                Percentage is set by account administrator.
              </div>
            }
            {compensationType === "lender_paid" && checkAccess([UR_Owner]) &&
              <div style={{ color: "#6E6E70", fontSize: 14, marginTop: 8, width: "100%", textAlign: "left", fontWeight: 400 }}>
                Percentage is set in <span style={{ color: "#325CEB", cursor: "pointer", fontWeight: 400, marginLeft: 4 }} onClick={handleEditCompensation}>Lender settings{svg_expand()}</span>
              </div>
            }
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Estimated closing fee
              {/* <span
                className="search-fields-content-item-content-item-svg cursor-pointer"
                onClick={handleEditCostDetails}
              >
                {edit_svg()}
              </span> */}
            </div>
            <div className="search-fields-content-item-content-item-select">
              {isCalculatedAtResults ? (
                <div
                  className="form-control"
                  style={{
                    background: "#ECECEC",
                    color: "#6E6E70",
                    fontFamily: "Inter",
                    fontWeight: 400,
                    height: 44,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {/* <span style={{ marginRight: 8 }}>$</span> */}
                  Fees shown on results page
                </div>
              ) : (
                <InputNumber
                  style={{ borderRadius: 6, height: 44, width: "100%" }}
                  prefix="$"
                  placeholder="Input"
                  disabled={true}
                  value={estimatedClosingFee}
                  onChange={updateEstimatedClosingFee}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                />
              )}
            </div>
            {/* {isCalculatedAtResults && (
                <div
                  style={{
                    color: "#6E6E70",
                    fontFamily: "Inter",
                    fontSize: 12,
                    lineHeight: "normal",
                    marginTop: 2,
                  }}
                >
                  *The estimate will be shown on the results page.
                </div>
              )} */}
            {checkAccess([UR_Owner]) && (
              <div style={{ color: "#325CEB", fontSize: 14, marginTop: 8, width: "100%", textAlign: "left", fontWeight: 400 }} 
                className="cursor-pointer"
                onClick={handleEditCostDetails}
              >
                Edit fees{svg_expand()}
              </div>
            )}
            {!checkAccess([UR_Owner]) && (
              <div style={{ color: "#6E6E70", fontSize: 14, marginTop: 8, width: "100%", textAlign: "left", fontWeight: 400 }}>
                Closing fee is set by account administrator.
              </div>
            )}
          </div>
          <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              AUS type
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select"
                mode="multiple"
                maxTagCount={1}
                maxTagPlaceholder={() =>
                  ausType.length > 1
                    ? "+" + (ausType.length - 1)
                    : ""
                }
                allowClear={true}  
                value={ausType}
                onChange={updateAusType}
              >
                <option value="DU">DU</option>
                <option value="LP">LP</option>
                <option value="Manual">Manual UW</option>
              </Select>
            </div>
          </div>
          {/* <div className="search-fields-content-item-content-item">
            <div className="search-fields-content-item-content-item-title">
              Buydown
            </div>
            <div className="search-fields-content-item-content-item-select">
              <Select
                style={{ width: "100%" }}
                type="text"
                placeholder="Select"
                value={buydown}
                allowClear={true}  
                onChange={updateBuydown}
              >
                <option value="3/2/1">3/2/1</option>
                <option value="2/1">2/1</option>
                <option value="1/1">1/1</option>
                <option value="1/0">1/0</option>
              </Select>
            </div>
          </div> */}
          <div className="search-fields-content-item-content-item">
            <Checkbox checked={isImpound} onChange={updateImpound}>
              Impound
            </Checkbox>
            {/* <Checkbox checked={isInterestOnly} onChange={updateInterestOnly}>
              Interest only
            </Checkbox> */}
            {/* <Checkbox
              checked={isWaiveLenderFee}
              onChange={updateWaiveLenderFee}
            >
              Waive Lender Fee?
            </Checkbox> */}
          </div>
        </div>
      </div>
    );
  };

  const getLender = () => {
    setIsLoading(true);
    const token = sessionStorage.getItem('ZeitroA')
    fetch('/data/getcustomerlenders', {
      method: 'GET',
      headers: {
          Authorization: 'Bearer ' + token,
          Cache: 'no-cache',
      },
  })
      .then((response) => {
          if (response.status !== 200) {
              console.warn(
                  'Looks like there was a problem. Status Code: ' +
                      response.status
              )
              return
          }
          // Examine the text in the response
          response.json().then((js) => {
              if (js.Status === 'OK') {
                  if (js.Lenders !== null) {
                      const hasLenders =
                          js.Lenders.some((item) => item.Active) ||
                          js.Lenders.some((item) => item.Hidden)
                      if (hasLenders) {
                          setHasLenders(true)
                      }
                  }
              }
          }).finally(() => {
            setIsLoading(false)
          })
      })
      .catch(function (err) {
          console.error('Fetch lenders Error : ', err)
      })
  }

  const check_property_value = (type, value) => {
    let propertyValue_ = propertyValue;
    let loanAmount_ = loanAmount;
    let downPayment_ = downPayment;
    if(type === 'propertyValue'){
     propertyValue_ = value
    }
    if(type === 'loanAmount'){
      loanAmount_ = value
    }
    if(type === 'downPayment'){
      downPayment_ = value
    }
    if(loanPurpose === 'Purchase'){
      if(propertyValue_ < downPayment_){
        // message.error('Property value must be greater than down payment.');
        setPropteryError('Property value must be greater than down payment.');
        return false;
      }else{
        setPropteryError('');
      }
    }else{
      if(propertyValue_ < loanAmount_){
        // message.error('Property value must be greater than loan amount.');
        setPropteryError('Property value must be greater than loan amount.');
        return false;
      }else{
        setPropteryError('');
      }
    }
  }

  const check_rates = () => {
    // console.log("check_rates", hasLenders);
    if(searchBy === 'rate' && targetRate === null){
      setTargetRateMessage('Please enter target rate');
      return;
    }else{
      setTargetRateMessage('');
    }

    if(!hasLenders){
      setIsOpen_no_lender(true);
      return;
    }
    if(check_property_value() === false){return};
    // 获取用户信息
    const savedUserInfo = JSON.parse(
      sessionStorage.getItem("statsig_user_info")
    );
    const customerid = com.getCustomerId();

    // 构建请求体
    const body = {

      Rate_CRAAdjustment: false, // flag
      Rate_LMIBAdjustment: false, // flag
      Rate_LMITAdjustment: false, // flag
      Rate_MMCTAdjustment: false, // flag
      appraisalWaiver: false, // flag
      borrowerPaidCompensationAmount: 0, // flag
      currentJobInMonths: 24, // flag
      familyRelatedOrSmallBusiness: false, // flag
      getFiles: false, // flag
      giftFundUsed: false, // flag
      // monthlyDebt: 1000, // flag
      // monthlyIncome: 10000, // flag
      numberOfOwnedProperties: 1, // flag
      pmi: 0.51, // flag
      point: [{lender: "default", percent: 1, fixed: 500}], // flag
      rsuAsIncome: -1, // flag
      unit: 1, // flag
      visaType: "H_1B", // flag

      // loan
      purpose: loanPurpose,
      loanTerm: loanTerm,
      loanTypes: loanType,
      propertyValue: propertyValue, // new
      downPayment: downPayment, // new
      loanAmount: loanAmount,
      upFrontMIP: upFrontMIP,
      upFrontMIP_Financed: upFrontMIP_Financed,
      LTV: ltv || getLTV(),
      CLTV:  ltv || getLTV(),// cltv, // todo // flag
      HCLTV:  ltv || getLTV(),// hcltv, // todo
      secondaryLoanAmount: secondaryLoanAmount, // new 
      // isSubordinateLiens: isSubordinateLiens, // new

      // property
      occupancy: com.getOccupancy(occupancy),
      property: com.getPropertyType(propertyType),
      state: state,
      county: county,
      isRural: isRural, // new
      isMixedUseProperty: isMixedUse, // new

      // borrower
      FICO: fico,
      monthlyIncome: parseFloat(monthlyIncome),
      monthlyDebt: parseFloat(monthlyDebt),
      dti: dti,
      citizenship: citizenship,
      firstTimeHomeBuyer: isFirstTimeHomeBuyer,
      selfEmployed: isSelfEmployed,

      // product
      searchBy: searchBy, // new
      targetPrice: targetPrice, // new
      targetRate: targetRate, // new
      targetPriceType: targetPriceType, // new
      lockDay: lockDay,
      compensationType: compensationType, // new
      compensationPercent: compensationPercent, // new
      estimatedClosingFee: parseFloat(estimatedClosingFee), 
      ausTypes: ausType, // new
      buyDown: buydown, // new

      isImpound: isImpound, // new
      escrowWaiver: !isImpound, // new

      isInterestOnly: isInterestOnly, // new
      isWaiveLenderFee: isWaiveLenderFee, // new
    };

    // 调用父组件的回调函数
    onCheckRates(body, savedUserInfo, customerid);
  };

  const handleEditCostDetails = () => {
    setShowEditCostDetails(true);
  };

  const handleEditCostDetailsModal = () => {
    setShowEditCostDetails(false);
  };
  let setEstClosingfee = (lodeStarConfig, closingFeeConfig) => {

    let data = {
        lodeStarConfig: {
            ...lodeStarConfig,
            isModified: true,
            enableCanNotShopServices: false,
            enablePrepaids: false,
            enableInitialEscrowPaymentsAtClosing: false
        },
        closingCostsDetail: closingFeeConfig
    }
    let token = sessionStorage.getItem("ZeitroA");
    fetch("/los/setloanestimatedclosingfee", {
        cache: "no-cache",
        method: "POST",
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Cache: "no-cache",
        },
        body: JSON.stringify(data)
    }).then(response => {
        if (!response.ok) {
        } else {
            setEstimatedClosingFee(totalClosingFee)
            getloanestimatedclosingfee()
        }
    }).catch(error => {
    })
  }

  const handleLodestarChange = (checked) => {
    let newLodeStarConfig = {
      ...lodeStarConfig,
      enableCanNotShopServices: checked,
      enableCanShopServices: checked,
      enableTaxesAndOtherGovernmentFees: checked,
      enablePrepaids: checked,
      enableInitialEscrowPaymentsAtClosing: checked,
      enableOther: checked,
    }
    const closingFee = closingCostRef.current.getClosingFee()
    setEstClosingfee(newLodeStarConfig, closingFee)
  };

  const handleConfigChange = (newConfig) => {
    const closingFee = closingCostRef.current.getClosingFee()
    setEstClosingfee(newConfig, closingFee)
  };

  const handleSaveClosingFee = () => {
    setEstimatedClosingFee(totalClosingFee);
    const closingFee = closingCostRef.current.getClosingFee();
    setEstClosingfee(lodeStarConfig, closingFee)
    handleEditCostDetailsModal();
  };

  const getEditCostsModal = () => {
    return (
      <Modal
        className="edit-fees-modal"
        centered
        destroyOnClose
        maskClosable={true}
        width={974}
        open={showEditCostDetails}
        title=""
        onCancel={handleEditCostDetailsModal}
        footer={null}
      >
        <div className="edit-fees-modal-title">Closing cost details</div>
        <div className="edit-fees-modal-content edit-fees-modal-content-new">
          <div style={{ marginBottom: 12 }}>
            <LodestarTipsCard
              initialConfig={lodeStarConfig}
              onLodestarChange={handleLodestarChange}
            />
          </div>
          <div className="estimatedclosingfee-container">
            <ClosingCost
              ref={closingCostRef}
              initialConfig={lodeStarConfig}
              initialClosingFee={closingFeeConfig}
              onConfigChange={handleConfigChange}
              onTotalFeesChange={(totalFees) => setTotalClosingFee(totalFees)}
            />
          </div>
          <div className="edit-fees-modal-footer">
            <Button
              className="edit-fees-modal-cancel"
              onClick={handleEditCostDetailsModal}
              variant="customize"
            >
              Cancel
            </Button>
            <Button
              className="edit-fees-modal-save"
              variant="primary"
              onClick={handleSaveClosingFee}
            >
              Save
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  const [addLenderModal, setAddLenderModal] = useState(false);

  const handleCloseAddLenderModal = () => {
    setAddLenderModal(false);
  };

  const AddLenderModal = () => {
    return (
      <Modal
        open={addLenderModal}
        onCancel={handleCloseAddLenderModal}
        centered
        footer={[
          <Button key="back" onClick={handleCloseAddLenderModal}>
            Cancel
          </Button>,
        ]}
        width={1200}
      >
        <Lenders addLenders={addLenders}/>
      </Modal>
    );
  };
  const svg_collapse = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8107 10.5607L16.75 9.5L12.1544 14.0956L7.56066 9.50184L6.5 10.5625L11.0937 15.1562L11.0931 15.1569L12.1538 16.2175L12.1544 16.2169L12.1569 16.2194L13.2175 15.1587L13.2151 15.1563L17.8107 10.5607Z" fill="#222222"/>
      </svg>
    )
  }

  const backToResult = () => {
    onBackToResult();
  }

  const addLenders = (has) => {
    setHasLenders(has);
    setIsOpen_no_lender(false);
    closeModal_no_lender();
    
    if (has) {
      setShouldCheckRatesAfterLenderUpdate(true);
    }
  }
  useEffect(() => {
    if(loanType.includes("fha") || loanType.includes("")){
      setUpFrontMIP(Number(loanPurpose === "Purchase" ? propertyValue - downPayment : loanAmount) * 0.0175);
      }else{
      setUpFrontMIP(0);
    }
  }, [loanType]);

  useEffect(() => {
    if (shouldCheckRatesAfterLenderUpdate && hasLenders) {
      setShouldCheckRatesAfterLenderUpdate(false);
      check_rates();
    }
  }, [hasLenders, shouldCheckRatesAfterLenderUpdate]);

  return (
    <div className="search-fields">
      <div className="title-box">
        <div className="title-box-left" style={{display: "flex", alignItems: "center"}}>
          Search fields
          {from === "result" && <div className="cursor-pointer" style={{marginLeft: 8}} onClick={() => backToResult()}>{svg_collapse()}</div>}
        </div>
        <div className="title-box-right">
          <div
            className="title-box-right-reset cursor-pointer"
            onClick={reset_all}
          >
            <span>Reset all</span>
          </div>
          {!isLoading && 
          <div
            className="title-box-right-check cursor-pointer"
            onClick={check_rates}
          >
            <span>Check rates</span>
          </div>}
        </div>
      </div>
      <div className="search-fields-content">
        {field_Loan()}
        {field_Property()}
        {field_Borrower()}
        {field_Product()}
      </div>

      {/* no lender existing */}
      <NoLenderModal isOpen={isOpen_no_lender} onClose={closeModal_no_lender} addLenders={addLenders}/>
      {getEditCostsModal()}
      <AddLenderModal />
    </div>
  );
};

export default SearchFields;
